import { DIFFERENTIATORS } from "../../data/landingContent";
import Reveal from "./Reveal";

export default function WhyDifferent() {
  return (
    <section className="daa-light why-different-section" aria-labelledby="why-diff-heading">
      <div className="wrap">
        <Reveal>
          <span className="kicker light">Why Deepaarogya</span>
          <h2 className="section-title light" id="why-diff-heading">
            Custom software for <b>your practice</b> — not a rigid template
          </h2>
          <p className="section-lede light">
            Most EMRs force you to change how you work. We configure OPD, IPD, physio, nutrition, and billing
            around your clinic&apos;s actual flow — with 24×7 deployment support.
          </p>
          <p className="doctors-joining-badge">
            Trusted by <strong>clinics and hospitals</strong> across India — customised to your workflow
          </p>
        </Reveal>

        <Reveal as="div" className="diff-grid reveal-stagger">
          {DIFFERENTIATORS.map((item) => (
            <article className="diff-card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
